module.exports = __webpack_public_path__ + "static/img/default-avatar.185955da.jpg";